import { useEffect } from 'react'
import Entity from '../types/Entity'

interface useInitPaginationProps {
  limit: number,
  enablePagination: boolean
  includedRows: Array<Entity>
  excludedRows: Array<Entity>
  setShowPagination: (showPagination: boolean) => void
}

const useInitPagination = (props: useInitPaginationProps) => {
  useEffect(() => {
    const showPagination: boolean = props.enablePagination && (props.includedRows.length > props.limit || props.excludedRows.length > props.limit)
    props.setShowPagination(showPagination)
  }, [props.includedRows, props.excludedRows])
}

export default useInitPagination
